module.exports = __webpack_public_path__ + "static/media/nytimes.com_interactive_2016_upshot_presidential-polls-forecast.html_plot.ad0c67a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nytimes.com_interactive_2016_upshot_presidential-polls-forecast.html_plot.png
// module id = 412
// module chunks = 0